import { render, staticRenderFns } from "./SinistersList.vue?vue&type=template&id=deefb2f2&scoped=true"
import script from "./SinistersList.vue?vue&type=script&lang=ts"
export * from "./SinistersList.vue?vue&type=script&lang=ts"
import style0 from "./SinistersList.vue?vue&type=style&index=0&id=deefb2f2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "deefb2f2",
  null
  
)

export default component.exports